import {AnyAction, ListenerEffect} from '@reduxjs/toolkit';
import {AppDispatch, ExtraArgs} from '../../createStore';
import {RootState} from '../../rootReducer';
import {getAllCalendarDays} from '../../data/calendar/selectors';
import {getMeetingsSettings} from '../../data/meetings/selectors';
import {loadAllMeetings} from '../../data/meetings/actions';

export const loadAllMeetingsEffect: ListenerEffect<AnyAction, RootState, AppDispatch, ExtraArgs> = (
  _action,
  {getState, dispatch},
) => {
  const state = getState();
  const days = getAllCalendarDays(state);
  const settings = getMeetingsSettings(state);

  dispatch(
    loadAllMeetings({
      from: days[0].date,
      to: days[days.length - 1].date,
      pageSize: settings.pageTimespanInDays,
    }),
  );
};
